/**
 * 历史节的状态筛选口径(2026-07-16 三线统一)。
 *
 * <p>★<b>没有「生成中」</b>:在途任务由页面顶部的「进行中」节独立拉取(bucket=running,不受筛选/分页影响),
 * 历史节拉 bucket=history(终态)。再放一个「生成中」chip 就是同一批任务的第二个入口 ——
 * 点了要么空、要么和上面那节重复。这是三段式骨架的必然结果,不是漏做。
 *
 * <p>放 lib/ 而非与 <MediaFilterChips> 同文件:组件文件混着导出常量/函数会破坏 react-refresh。
 */
export type MediaStatusFilter = "ALL" | "SUCCESS" | "PARTIAL" | "FAILED";

export const MEDIA_STATUS_OPTIONS: { value: MediaStatusFilter; label: string }[] = [
  { value: "ALL", label: "全部" },
  { value: "SUCCESS", label: "成功" },
  { value: "PARTIAL", label: "部分" },
  { value: "FAILED", label: "失败" },
];

/** URL 里的 status 参数 → 合法筛选值(非法/缺省回落 ALL)。 */
export function parseStatusFilter(raw: string | null): MediaStatusFilter {
  return raw === "SUCCESS" || raw === "PARTIAL" || raw === "FAILED" ? raw : "ALL";
}
